import axios from 'api';
const config = {
  headers: {
    // withCredentials: true
  }
};
export const getNotifications = async (params, signal) => {
  return axios.get(`api/notifications?page=${params.page}&page_size=${params.page_size}`, { signal: signal });
};
export const getUnreadNotifications = async (signal) => {
  return axios.get(`api/notifications/unread/`, { ...config, signal: signal });
};
export const markAsReadNotifications = async (params, signal) => {
  return axios.patch(`api/notifications/mark_as_read/`, params, { signal: signal });
};
export const markAsUnReadNotifications = async (params, signal) => {
  return axios.patch(`api/notifications/mark_unread/`, params, { signal: signal });
};
export const deletedNotifications = async (params, signal) => {
  return axios.delete(`api/notifications/delete/`, { data: params }, { signal: signal });
};
